@if (vm) {
  <section data-testid="maintenance-banner">
    <div class="content">
      <h2 data-testid="maintenance-banner-title">{{ vm.title }}</h2>
      <p class="body" data-testid="maintenance-banner-message">{{ vm.message }}</p>
      @if (vm.contactCentreMessage) {
        <p class="body" data-testid="maintenance-banner-contact-centre-message">{{ vm.contactCentreMessage }}</p>
      }
      @if (vm.apologyMessage) {
        <p class="body" data-testid="maintenance-banner-apology-message">{{ vm.apologyMessage }}</p>
      }
    </div>

    <button type="button" class="close" aria-label="Close" data-testid="maintenance-banner-close" (click)="dismiss()">
      <i class="fa-light fa-xmark"></i>
    </button>
  </section>
}
